// start:ng42.barrel
export * from './yards.service';
// end:ng42.barrel

